import { useContext, useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import {
  BaseUrl,
  GetPhonePayPaymentLink,

} from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import {
  pujaServiceID,
  pujaSubServiceID,
  ServiceDiscounts,
} from "../../Components/enum";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { handleProceedRemainingPayment } from "../../Components/RazorPay/RazorPayFunction";
import DeliveryTracker from "../../Components/DeliveryTracker/DeliveryTracker.jsx";
import LazySection from "../Home/LazySection.jsx";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi.jsx";
import { t } from "i18next";
import {
  GetPujaOrderDetails,
  GetPujaOrderTrackingDetails,
  PayRemainingPujaBookingAmount,
} from "../../ApiServices/Puja/PujaApi.jsx";
import { Button, Col, Image, Row } from "react-bootstrap";
import pandit from "../../assets/images/new/devi-ma.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import CountdownTimer from "./CountdownTimer.jsx";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import HoroscopeBannerImg from "../../assets/images/new/faqbanner.png";
import Breadcrumbs from "../../Components/Breadcrumb.jsx";
import ErrorMassagePupUp from "../../Components/ErrorMassagePupUp.jsx";

const RemedyPujaOrderDetails = () => {
  const userKeyID = localStorage.getItem("userKeyID");
  const location = useLocation();
  const navigate = useNavigate();
  const [order, setOrders] = useState({});
  const { setLoader, selectedLanguageID } = useContext(LoaderContext);
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null);
  const [isRemainingPaymentDone, setIsRemainingPaymentDone] = useState(false);
  const Remaining_Amount = Math.round(order?.remainingAmount);
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;
  const [customErrorMassage, setCustomErrorMassage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [readMoreDetailed, setReadMoreDetailed] = useState(false);
  const maxChars = 560; // number of characters to show initially

  useEffect(() => {
    GetPujaOrderDetailsData(location?.state?.order?.pujaBookingKeyID);
    GetPujaOrderTrackingDetailsData(location?.state?.order?.pujaBookingKeyID);
  }, []);

  useEffect(() => {
    if (isRemainingPaymentDone) {
      GetPujaOrderDetailsData(location?.state?.order?.pujaBookingKeyID);
      setIsRemainingPaymentDone(false);
    }
  }, [isRemainingPaymentDone]);

  useEffect(() => {
    GetPujaOrderDetailsData(location?.state?.order?.pujaBookingKeyID);
  }, [selectedLanguageID]);

  const GetPujaOrderDetailsData = async (PujaBookingKeyID) => {
    setLoader(true);
    debugger
    try {
      const response = await GetPujaOrderDetails(
        PujaBookingKeyID,
        selectedLanguageID
      );

      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || [];
        setOrders(list[0]);
      }
    } catch (error) {
      setLoader(false);
      setCustomErrorMassage(error?.response?.data?.errorMessage)
      setShowErrorModal(true)
      console.log(error);
    }
  };

  const GetPujaOrderTrackingDetailsData = async (PujaBookingKeyID) => {
    setLoader(true);
    try {
      const response = await GetPujaOrderTrackingDetails(
        PujaBookingKeyID,
        userKeyID,
        Number(selectedLanguageID)
      );

      if (response?.statusCode === 200) {
        setLoader(false);
        const list = response?.responseData?.data || [];
        setOrderTrackingDetails(list)
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  function formatToIndianCurrency(amount) {
    if (!amount) return "";

    const [integerPart, decimalPart] = amount.toString().split(".");

    // Format the integer part using Indian numbering system
    const formattedIntegerPart = integerPart.replace(
      // Match groups of 3 digits initially, then groups of 2 digits
      /(\d)(?=(\d\d)+\d$)/g,
      "$1,"
    );

    // Return the formatted value with the decimal part (if present)
    return decimalPart !== undefined
      ? `${formattedIntegerPart}.${decimalPart}`
      : formattedIntegerPart;
  }
  const handleDownloadInvoice = (PB_ID) => {
    window.open(order?.invoicePDFURL, "_blank");
  };

  const handleProceedRemainingPujaPayment = async () => {
    if (order.remainingAmount === 0) {
      alert("All the amount already paid");
      return;
    }

    const PlaceOrderResponse = await handleProceedRemainingPayment(
      Math.round(order.remainingAmount)
    );

    setLoader(true);
    if (PlaceOrderResponse?.status === 1) {
      try {
        const response = await PayRemainingPujaBookingAmount({
          pujaServiceID: order?.pujaServiceID,
          pujaSubServiceID: order?.pujaSubServiceID,
          userKeyID: userKeyID,
          pujaBookingKeyID: order?.pujaBookingKeyID,
          transactionAmount: order?.remainingAmount,
          paymentTypeID: 2,
          transactionID: PlaceOrderResponse?.razorpay_payment_id,
          applicationType: "Website",
        });

        if (response?.statusCode === 200) {
          setLoader(false);
          setIsRemainingPaymentDone(true);
        } else {
          setLoader(false);
          alert("Failed to pay amount. Try again !");
        }
      } catch (error) {
        setLoader(false);
        alert("Failed to pay amount. Try again !");
        console.log(error);
      }
    } else if (PlaceOrderResponse?.status === 0) {
      setLoader(false);
      alert("Order Failed !");
    }
  };

  const plainText = (() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = order.pujaDetails;
    return tempDiv.innerText || tempDiv.textContent || "";
  })();

  const pujaSamagriText = (() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = order.pujaSamagri;
    return tempDiv.innerText || tempDiv.textContent || "";
  })();

  const toggleReadMore = () => setReadMore(!readMore);
  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];


  const CloseModal = () => {
    setShowErrorModal(false)
    navigate(-1)
  }
  return (
    <>
      <section className="page-header" style={{ paddingBottom: "30px" }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: "block" }}>
          <h2 className="page-header__title bw-split-in-left">{t("Order Details")}</h2>
          <div className="d-flex justify-content-center">

            <Breadcrumbs />
          </div>
        </div>

      </section>

      <section className="mt-2">
        <div className="container">
          {/* Main Content Row */}
          <Row className="justify-content-center mt-1">
            {/* Left Column: Image Gallery */}
            <Col md={5}>
              <div className="position-relative d-flex justify-content-center">
                <Image
                  src={order?.pujaImageUrl || pandit}
                  style={{ height: `${order?.pujaImageUrl ? "" : "324px"}` }}
                  className="img-fluid-custom"
                  rounded
                />
              </div>
              <div className="mt-3">
                {order?.isPhysicallyAttend && (
                  <div
                    style={{
                      background: "linear-gradient(90deg, #eeb11a, #a52444)",
                      padding: "5px 15px",
                      borderRadius: "8px",
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "white",
                      minWidth: "320px",
                      fontSize: '16px'
                    }}
                  >
                    {t("Note : I will attend puja physically.")}

                  </div>
                )}
              </div>
              <div className="d-block  d-md-none">
                <hr />
              </div>
            </Col>

            {/* Right Column: Puja Details */}
            <Col md={7} className=" mt-md-0">
              <div className=" h-100">
                <div className=" px-md-4">
                  {/* Title and Subtitle */}
                  <h4 className="mb-1 fw-bold">{order?.pujaName}</h4>
                  <span style={{ fontSize: "16px", color: "#a52444" }}>
                    {order?.benefits}
                  </span>
                  {/* Puja Price  */}

                  <div className="price-tag  position-relative align-items-start mb-2">
                    <div
                      className="text-dark px-3  rounded"
                      style={{ background: "#efb423", marginRight: "10px" }}
                    >
                      <strong>₹ {Math.round(order.pujaPrice)}</strong>
                    </div>
                  </div>

                  {/* Short Description */}
                  {(order?.pujaSubServiceID === 3 || order?.pujaSubServiceID === 4) ? (
                    order?.description !== null &&
                    order?.description !== undefined && (
                      <p className="small" dangerouslySetInnerHTML={{
                        __html: order.description,
                      }}>

                      </p>
                    )
                  ) : (
                    order?.pujaDetails !== null &&
                    order?.pujaDetails !== undefined && (
                      <p className="small">
                        {readMore
                          ? plainText
                          : plainText.length > maxChars
                            ? `${plainText.substring(0, maxChars)}...`
                            : plainText}
                        {plainText.length > maxChars && (
                          <span
                            onClick={toggleReadMore}
                            // className="btn-fancy"
                            style={{ color: "#a52444", cursor: "pointer" }}
                          >
                            {readMore ? "Read Less" : "Read More"}
                          </span>
                        )}
                      </p>
                    )
                  )}


                  {order?.pujaSubServiceID !== 5 &&
                    order?.pujaSubServiceID !== 6 &&
                    order?.templeAddress !== undefined &&
                    order?.templeAddress !== null && (
                      <>
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faLocationDot}
                            size="1x"
                            className="text-yellow-500 "
                          />

                          <span className="small">
                            {order?.templeAddress}
                          </span>
                        </div>
                      </>
                    )}

                  {order?.remainingAmount > 0 && (
                    <div className='d-flex justify-content-start'>
                      <Button
                        onClick={() => handleProceedRemainingPujaPayment()}

                        size='lg'
                        className="w-50 z-100 rounded-pill  py-1 mt-1 pulse-button  mb-2"
                      >
                        {t("Pay Now")}
                      </Button>
                    </div>
                  )}


                </div>
              </div>
            </Col>
          </Row>


        </div>
        {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

          <div >
            <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
          </div>
        )}
      </section>
      <div className="container">
        {(order?.isWetSamagriNeeded || order?.isDrySamagriNeeded) && (order.pujaSamagri !== null && order.pujaSamagri !== undefined) && (
          <div className="m-1 p-3">
            <h5>{t("Puja Samagri")}:</h5>
            <p
              dangerouslySetInnerHTML={{
                __html: order.pujaSamagri,
              }}
            />
          </div>
        )}
      </div>
      <div className="container my-4">
        <div className="row g-1">
          {/* Puja Details */}
          {(order?.pujaSubServiceID === 3 || order?.pujaSubServiceID === 4) ? (
            <div className={`${order?.panditStatus !== "Pending" ? 'col-md-4' : 'col-md-6'}`}>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold lh-base">
                    {t("Subscription Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Name")}</td>
                        <td className=" fw-bold">{order.pujaName}</td>
                      </tr>
                      <tr>
                        <td>{t("Subscription Package Name")}</td>
                        <td className=" fw-bold">{order.title}</td>
                      </tr>

                      <tr>
                        <td>{t("Package sub-title")}</td>
                        <td className=" fw-bold">{order.subTitle}</td>
                      </tr>
                      <tr>
                        <td>{t("Timeline")}</td>
                        <td className=" fw-bold">{order.timeLine}</td>
                      </tr>
                      <tr>
                        <td>{t("Payment Mode")}</td>
                        <td>
                          <i className="bi bi-credit-card"></i>{" "}
                          {t(order.paymentType)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Payment Status")}</td>
                        <td className="fw-bold ">
                          {order.paymentStatus === "Complete"
                            ? t("Completed")
                            : t(order.paymentStatus)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Transaction Amount")} (₹)</td>
                        <td>{formatToIndianCurrency(order.transactionAmount)}</td>
                      </tr>
                      {order.remainingAmount > 0 && (
                        <tr>
                          <td>{t("Remaining Amount")} (₹) </td>
                          <td className="d-flex justify-content-between">
                            <span>

                              {order.remainingAmount > 0
                                ? formatToIndianCurrency(order.remainingAmount)
                                : 0}
                            </span>

                            <span >
                              <button
                                onClick={() => handleProceedRemainingPujaPayment()}
                                className="Normal-app-btn"
                                style={{ padding: "5px 16px", fontSize: "14px" }}
                              >
                                Pay now
                              </button>
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className={`${order?.panditStatus !== "Pending" ? 'col-md-4' : 'col-md-6'}`}>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold lh-base">
                    {t("Puja Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Puja Name")}</td>
                        <td className=" fw-bold">{order.pujaName}</td>
                      </tr>
                      <tr>
                        <td>{t("Booking Date")}</td>
                        <td className=" fw-bold">{order.bookingDate}</td>
                      </tr>
                      {order?.pujaSubServiceID !== 5 &&
                        order?.pujaSubServiceID !== 6 && (
                          <>
                            <tr>
                              <td>{t("Gotra")}</td>
                              <td className=" fw-bold">{order.gotra}</td>
                            </tr>
                            <tr>
                              <td>{t("Birth Date")}</td>
                              <td>{order.dateOfBirth}</td>
                            </tr>

                            <tr>
                              <td>{t("Birth Time")}</td>
                              <td>{order.dateOfTime}</td>
                            </tr>
                          </>
                        )}
                      {order?.pujaSubServiceID === 5 && (
                        <>
                          <tr>
                            <td>{t("Puja Date")}</td>
                            <td className=" fw-bold">{order.pujaStartDate}</td>
                          </tr>
                          {order.pujaStartTime && (
                            <tr>
                              <td>{t("Puja Time")}</td>
                              <td className=" fw-bold">{order.pujaStartTime}</td>
                            </tr>
                          )}
                          {order.languageName && (
                            <tr>
                              <td>{t("puja Language")}</td>
                              <td>{order.languageName}</td>
                            </tr>
                          )}

                          {order.stateName && (
                            <tr>
                              <td>{t("State")}</td>
                              <td>{order.stateName}</td>
                            </tr>
                          )}
                          {order.districtName && (
                            <tr>
                              <td>{t("District")}</td>
                              <td>{order.districtName}</td>
                            </tr>
                          )}
                          {order.address && (
                            <tr>
                              <td>{t("Address")}</td>
                              <td>{order.address}</td>
                            </tr>
                          )}

                        </>
                      )}
                      {order?.pujaSubServiceID === 6 && (
                        <>
                          <tr>
                            <td>{t("Puja  Date")}</td>
                            <td className=" fw-bold">
                              {order.pujaStartDate} to {order?.pujaEndDate}
                            </td>
                          </tr>

                          <tr>
                            <td>{t("Puja Time")}</td>
                            <td>
                              {order.pujaStartTime}
                            </td>
                          </tr>
                          <tr>
                            <td>{t("Puja Language")}</td>
                            <td>{order.languageName || "-"}</td>
                          </tr>

                          <tr>
                            <td>{t("State")}</td>
                            <td>{order.stateName}</td>
                          </tr>
                          <tr>
                            <td>{t("District")}</td>
                            <td>{order.districtName}</td>
                          </tr>
                          <tr>
                            <td>{t("Address")}</td>
                            <td>{order.address}</td>
                          </tr>
                          <tr>
                            <td>{t("Need Wet Samgri")}</td>
                            <td>{order.isWetSamagriNeeded ? "Yes" : "No"}</td>
                          </tr>
                          <tr>
                            <td>{t("Need Dry Samgri")}</td>
                            <td>{order.isDrySamagriNeeded ? "Yes" : "No"}</td>
                          </tr>
                        </>
                      )}

                      {order.NeedDrySamagri === "yes" &&
                        order.NeedWetSamagri === "yes" ? (
                        <tr>
                          <td>{t("Samagri")}</td>
                          <td>{t("Yes")}</td>
                        </tr>
                      ) : order.NeedDrySamagri === "yes" &&
                        order.NeedWetSamagri === "no" ? (
                        <tr>
                          <td>{"Dry Samagri"}</td>
                          <td>{"Yes"}</td>
                        </tr>
                      ) : order.NeedDrySamagri === "no" &&
                        order.NeedWetSamagri === "yes" ? (
                        <tr>
                          <td>{t("Wet Samagri")}</td>
                          <td>{t("Yes")}</td>
                        </tr>
                      ) : (
                        ""
                      )}

                      <tr>
                        <td>{t("Payment Mode")}</td>
                        <td>
                          <i className="bi bi-credit-card"></i>{" "}
                          {t(order.paymentType)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Payment Status")}</td>
                        <td className="fw-bold ">
                          {order.paymentStatus === "Complete"
                            ? t("Completed")
                            : t(order.paymentStatus)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t("Transaction Amount")} (₹)</td>
                        <td>{formatToIndianCurrency(order.transactionAmount)}</td>
                      </tr>
                      {order.remainingAmount > 0 && (
                        <tr>
                          <td>{t("Remaining Amount")} (₹) </td>
                          <td className="d-flex justify-content-between">
                            <span>

                              {order.remainingAmount > 0
                                ? formatToIndianCurrency(order.remainingAmount)
                                : 0}
                            </span>

                            <span >
                              <button
                                onClick={() => handleProceedRemainingPujaPayment()}
                                className="Normal-app-btn"
                                style={{ padding: "5px 16px", fontSize: "14px" }}
                              >
                                Pay now
                              </button>
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}


          {/* Pandit Details */}
          {order?.panditStatus !== "Pending" && (
            <div className="col-md-4">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title text-center fw-bold lh-base">
                    {t("Pandit Details")}
                  </h5>
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td>{t("Pandit Name")}</td>
                        <td className="text-end">
                          {order.panditName || "-"}
                        </td>
                      </tr>




                      <tr>
                        <td>{t("Pandit Contact Number")}</td>
                        <td className="text-end">
                          {order.panditContactNumber || '-'}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          )}


          {/* Price Details */}
          <div className="col-md-4">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-center fw-bold lh-base">
                  {t("Price Details")}
                </h5>
                <table className="table table-bordered table-striped">
                  <tbody>
                    <tr>
                      <td>{t("Puja Price")} (₹)</td>
                      <td className="text-end">
                        {formatToIndianCurrency(
                          Math.round(Number(order.pujaPrice)) || 0
                        ) || 0}
                      </td>
                    </tr>

                    {Number(order.couponCodeAmount) !== 0 && (
                      <tr>
                        <td>{t("Applied Coupon Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(Number(order.couponCodeAmount))
                          )}
                        </td>
                      </tr>
                    )}

                    {order.isDrySamagriNeeded && !order.isWetSamagriNeeded && (
                      <tr>
                        <td>{t("Dry Samagri Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(Number(order.drySamagriPrice))
                          )}
                        </td>
                      </tr>
                    )}

                    {order.isWetSamagriNeeded && !order.isDrySamagriNeeded && (
                      <tr>
                        <td>{t("Wet Samagri Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(Number(order.wetSamagriPrice))
                          )}
                        </td>
                      </tr>
                    )}
                    {order.isWetSamagriNeeded && order.isDrySamagriNeeded && (
                      <tr>
                        <td>{t("Samagri Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(
                              Number(order.wetSamagriPrice) +
                              Number(order.drySamagriPrice)
                            )
                          )}
                        </td>
                      </tr>
                    )}

                    {Number(order.walletAmount) !== 0 && (
                      <tr>
                        <td>{t("Applied Wallet Amount")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(Number(order.walletAmount))
                          )}
                        </td>
                      </tr>
                    )}

                    {Number(order.convenienceFee) > 0 && (
                      <tr>
                        <td>{t("Convenience Fee")} (₹)</td>
                        <td className="text-end">
                          {formatToIndianCurrency(
                            Math.round(Number(order.convenienceFee))
                          )}
                        </td>
                      </tr>
                    )}

                    <tr className="fw-bold">
                      <td>{t("Total Amount")} (₹)</td>
                      <td className="text-end">
                        {formatToIndianCurrency(Math.round(order.totalAmount))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {order.invoicePDFURL !== null && (
              <a
                target="_blank"
                className="careox-btn mt-2"
                style={{ cursor: "pointer" }}
                onClick={() => handleDownloadInvoice(order.PB_ID)}
              >
                {t("Download Invoice")}
              </a>
            )}
          </div>



        </div>
      </div>

      <ErrorMassagePupUp Massage={customErrorMassage} show={showErrorModal} onHide={() => CloseModal()} />
    </>
  );
};

export default RemedyPujaOrderDetails;
